module.exports = __webpack_public_path__ + "img/3.c016ede0.jpg";